export const boxOffice = (
	eventId = ':event'
) => `events/${eventId}/artists/legacy-box-office`;
